

import React from 'react';
import RequestProvider from '../../RequestProvider';
import getBynderAssetDownloadUrl from '../api/getBynderAssetDownloadUrl';
import DownloadAssetMenuComponent from '../components/DownloadAssetMenu';

const DownloadAssetMenu = (props) =>
<RequestProvider requests={{ getBynderAssetDownloadUrl: getBynderAssetDownloadUrl() }}>
    {(requests) => <DownloadAssetMenuComponent {...props} {...requests} />}
  </RequestProvider>;


export default DownloadAssetMenu;